//
//
//
//
//
//
//
//
//
//
//

export default {
  name:"DistributeSpacingVIcon",
  props:{
    size: {
      type: String,
      default: 'inherit'
    },
    rotate: {
      type: String,
      default: '0'
    },
    fill: {
      type: String,
      default: 'none'
    }
  }
};
